var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _path8, _path9, _rect, _path10, _rect2, _rect3, _rect4, _rect5, _polygon, _circle4, _polygon2, _path11, _polygon3, _path12, _path13, _path14, _path15, _circle5, _path16, _rect6, _path17, _path18, _rect7, _path19, _circle6, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawScheduleRe2Vro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "579.232px",
    height: "563.506px",
    viewBox: "0 0 579.232 563.506",
    enableBackground: "new 0 0 579.232 563.506",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M235.761,455.827l-10.97,10.099l8.718-14.628c-6.868-12.456-18.103-23.222-18.103-23.222 s-23.305,22.33-23.305,39.88c0,17.554,10.434,23.681,23.305,23.681c12.872,0,23.304-6.128,23.304-23.681 C238.712,464.051,237.556,459.908,235.761,455.827z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M221.969,466.473v0.866c-0.051,10.057-1.747,17.901-5.075,23.426c-0.047,0.083-0.099,0.161-0.146,0.241 l-0.373-0.227l-0.355-0.223c3.692-5.967,4.998-14.399,5.045-23.171c0.004-0.283,0.009-0.569,0.004-0.857 c-0.013-3.713-0.24-7.469-0.604-11.118c-0.026-0.283-0.057-0.568-0.086-0.857c-0.505-4.813-1.233-9.413-1.978-13.409 c-0.053-0.282-0.108-0.564-0.164-0.844c-1.289-6.758-2.604-11.654-2.903-12.738c-0.034-0.132-0.056-0.205-0.06-0.223l0.406-0.114 l0.005-0.006l0.41-0.115c0.005,0.019,0.077,0.261,0.197,0.716c0.458,1.696,1.648,6.3,2.817,12.372 c0.052,0.276,0.107,0.558,0.158,0.84c0.608,3.241,1.204,6.865,1.675,10.669c0.119,0.954,0.227,1.896,0.321,2.826 c0.035,0.286,0.064,0.574,0.089,0.857C221.75,459.329,221.955,463.024,221.969,466.473z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M219.112,440.191c-0.286,0.039-0.579,0.077-0.874,0.107c-0.802,0.083-1.608,0.125-2.415,0.125 c-3.438,0.006-6.833-0.762-9.937-2.245c-0.18,0.229-0.36,0.454-0.544,0.687c3.265,1.593,6.849,2.418,10.48,2.415 c0.862,0,1.722-0.047,2.579-0.137c0.291-0.029,0.582-0.068,0.87-0.111c2.369-0.34,4.671-1.037,6.831-2.069 c-0.185-0.234-0.364-0.466-0.54-0.692C223.52,439.225,221.345,439.872,219.112,440.191z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M221.267,454.527c-0.295,0.019-0.591,0.024-0.886,0.024c-0.09,0.006-0.185,0.006-0.274,0.006 c-7.562,0-14.646-3.7-18.965-9.907c-0.171,0.252-0.343,0.505-0.51,0.764c4.5,6.276,11.75,9.999,19.475,10c0.12,0,0.24,0,0.36-0.004 c0.3-0.005,0.595-0.013,0.89-0.026c4.573-0.235,8.982-1.78,12.699-4.454c-0.137-0.253-0.274-0.506-0.416-0.759 C230.028,452.796,225.729,454.312,221.267,454.527z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M221.969,466.473c-0.299,0.026-0.599,0.044-0.899,0.056c-0.321,0.014-0.642,0.021-0.964,0.021 c-10.283-0.011-19.327-6.799-22.211-16.668c-0.192,0.347-0.385,0.688-0.57,1.037c3.245,9.832,12.426,16.478,22.781,16.487 c0.321,0,0.643-0.004,0.959-0.02c0.304-0.01,0.604-0.025,0.903-0.047c6.056-0.474,11.705-3.231,15.804-7.714 c-0.09-0.317-0.192-0.63-0.295-0.948C233.519,463.193,227.955,465.989,221.969,466.473z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M493.758,104.508H73.724c-0.336-0.001-0.609-0.274-0.608-0.611c0-0.336,0.272-0.607,0.608-0.608h420.034 c0.336,0.001,0.609,0.275,0.607,0.612C494.363,104.235,494.094,104.507,493.758,104.508z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 87.445,
    cy: 89.268,
    r: 6.706
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 110.612,
    cy: 89.268,
    r: 6.706
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 133.777,
    cy: 89.268,
    r: 6.706
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M479.877,86.664h-16.46c-0.673-0.002-1.217-0.55-1.214-1.225c0.003-0.67,0.543-1.212,1.214-1.214h16.46 c0.673-0.002,1.222,0.541,1.225,1.214c0.002,0.673-0.541,1.222-1.215,1.225C479.884,86.664,479.881,86.664,479.877,86.664z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M479.877,91.235h-16.46c-0.673-0.002-1.217-0.55-1.214-1.224c0.003-0.669,0.543-1.212,1.214-1.214h16.46 c0.673-0.002,1.222,0.541,1.225,1.214c0.002,0.674-0.541,1.222-1.215,1.224C479.884,91.235,479.881,91.235,479.877,91.235z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M479.877,95.808h-16.46c-0.673-0.003-1.217-0.551-1.214-1.224c0.003-0.67,0.543-1.212,1.214-1.214h16.46 c0.673-0.003,1.222,0.54,1.225,1.214c0.002,0.673-0.541,1.221-1.215,1.224C479.884,95.808,479.881,95.808,479.877,95.808z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.769,
    y: 132.077,
    fill: "#F0F0F0",
    width: 384.923,
    height: 203.938
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M470.691,170.251v-2h-74.93v-36.174h-1.998v36.174h-74.931v-36.174h-1.999v36.174h-74.929v-36.174h-2v36.174 h-74.93v-36.174h-2v36.174H85.769v2h77.206v39.963H85.769v2h77.206v39.963H85.769v2h77.206v39.955H85.769v2.001h77.206v39.882h2 v-39.882h74.93v39.882h2v-39.882h74.929v39.882h1.999v-39.882h74.931v39.882h1.998v-39.882h74.93v-2.001h-74.93v-39.955h74.93v-2 h-74.93v-39.963h74.93v-2h-74.93v-39.963H470.691z M239.904,294.132h-74.93v-39.955h74.93V294.132z M239.904,252.177h-74.93v-39.963 h74.93V252.177z M239.904,210.214h-74.93v-39.963h74.93V210.214z M316.833,294.132h-74.929v-39.955h74.929V294.132z  M316.833,252.177h-74.929v-39.963h74.929V252.177z M316.833,210.214h-74.929v-39.963h74.929V210.214z M393.764,294.132h-74.931 v-39.955h74.931V294.132z M393.764,252.177h-74.931v-39.963h74.931V252.177z M393.764,210.214h-74.931v-39.963h74.931V210.214z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179.879,
    y: 179.97,
    fill: "#CACACA",
    width: 25.752,
    height: 24.931
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 416.967,
    y: 260.696,
    fill: "#CACACA",
    width: 25.75,
    height: 24.932
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.879,
    y: 302.15,
    fill: "#CACACA",
    width: 25.752,
    height: 24.931
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 195.491,
    y: 175.345,
    fill: "#23CACB",
    width: 25.75,
    height: 24.931
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFB6B6",
    points: "342.296,278.977 372.854,251.75 381.869,256.218 345.217,294.659 "
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB6B6",
    cx: 376.875,
    cy: 253.835,
    r: 7.273
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFB6B6",
    points: "313.691,483.904 306.46,483.904 303.02,456.015 313.692,456.015 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M315.536,490.913l-23.316-0.001v-0.295c0.001-5.012,4.063-9.075,9.076-9.075l0,0h14.24V490.913z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFB6B6",
    points: "287.51,483.904 280.278,483.904 276.838,456.015 287.51,456.015 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M289.354,490.913l-23.315-0.001v-0.295c0-5.012,4.063-9.075,9.075-9.075l0,0h14.24V490.913L289.354,490.913z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M319.765,324.477c0,0,18.183-1.454,12.364,30.544c-5.818,31.999-17.87,119.534-17.87,119.534l-10.926,1.502 l-6.455-116.769l-4.884,116.769l-13.896-1.502l-13.605-125.354c0,0-4.369-10.076-0.002-17.037 C268.856,325.203,319.765,324.477,319.765,324.477z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M308.128,245.205l5.049-2.705c0,0,12.437-1.061,17.512,13.549l13.46,20.331l21.818-18.909l9.454,6.545 l-27.497,32.817l-11.433,1.462l-24.727-32L308.128,245.205z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M289.811,186.201c-20.74,0-26.545,22.783-26.545,35.636s11.884,10.909,26.545,10.909 c6.293,0,12.07,0.354,16.62-0.253l2.188-5.343l1.762,4.427c3.733-1.372,5.977-4.16,5.977-9.741 C316.356,208.983,311.265,186.201,289.811,186.201z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB6B6",
    cx: 289.723,
    cy: 214.861,
    r: 17.862
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M269.084,213.109L269.084,213.109h7.065l3.116-8.728l0.624,8.728h3.377l1.817-5.091l0.364,5.091h25.09l0,0 c0-10.443-8.465-18.909-18.909-18.909h-3.636C277.549,194.2,269.084,202.666,269.084,213.109z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 362.76,
    y: 226.253,
    fill: "#23CACB",
    width: 25.751,
    height: 24.931
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M325.416,317.896c-2.743,0.033-11.004-48.982-11.004-48.982l-1.235-26.415l-9.027-0.303v-0.594 c0-2.482-2.013-4.494-4.496-4.494h-17.189c-2.371,0-4.332,1.843-4.481,4.208l-7.078-0.238l-12.258,38.948 c0,0,11.295,36.188,5.844,52.137c0,0,53.118,4.561,63.287-5.563C327.777,326.601,328.158,317.86,325.416,317.896z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M273.947,245.932l-3.042-4.852c0,0-9.899-2.446-13.974,4.113c-4.075,6.558-16.053,42.097-16.053,42.097 l12.363,4.363l14.03-19.667L273.947,245.932z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 279.125,
    y: 271.343,
    fill: "#23CACB",
    width: 25.75,
    height: 24.931
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB6B6",
    d: "M259.369,280.354l-8.959-0.948l0,0c-2.06,4.395-0.167,9.628,4.228,11.688 c0.641,0.301,1.316,0.522,2.011,0.66l35.449,7.075l-3.698-11.389L259.369,280.354z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB6B6",
    cx: 292.202,
    cy: 291.689,
    r: 7.273
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M283.124,299.182l-27.006-6.17c-3.98-0.921-7.188-3.857-8.459-7.739l-1.091-3.365l7.009-5.517l32.109,8.975 L283.124,299.182z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M434.883,492.376H157.796c-0.402,0-0.727-0.325-0.727-0.728c0-0.401,0.325-0.728,0.727-0.728h277.086 c0.4,0,0.728,0.325,0.728,0.728S435.283,492.376,434.883,492.376z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawScheduleRe2Vro);
export default __webpack_public_path__ + "static/media/undraw_schedule_re_2vro.64f5014433902d6786c26a784dcf69d4.svg";
export { ForwardRef as ReactComponent };